import styles from './ButtonGroup.module.scss';

export const ButtonGroup = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return <div className={`${styles.buttonGroup} ${className}`}>{children}</div>;
};